export function CoreRouterConfig (
  $locationProvider: ng.ILocationProvider
) {
  $locationProvider.hashPrefix('');
};
